import { atom } from "recoil"


export const edocCertificateSelect = atom({
	key: "edocCertificateSelect",
	default: {
		docKndCode: "",
		title:""
	}
})

export const edocViewerState = atom({
	key: "edocViewerState",
	default: {
		show: false,
		type:"",
		data:undefined

	}
})
export const edocSubmitAddState = atom({
	key: "edocSubmitAddState",
	default: {
		show: false
	}
})

/// 전자문서 지갑 주소 state
export const eDocWalletAddr = atom({
	key: "eDocWalletAddr",
	default: ""
})
/// 제출할 전자문서 리스트
export const eDocSubmitProofs = atom({
	key: "eDocSubmitProofs",
	default: []
})

/// 수취기관 리스트
export const eDocDistListState = atom({
	key: "eDocDistListState",
	default: []
})

/// 라온 시큐어 전자서명 요청 응답 state
export const raonCertRequestResponse = atom({
	key: "raonCertRequestResponse",
	default: undefined
})